var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopmodalIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6a1.003 1.003 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1.003 1.003 0 0 1-1-1zm18 16a13.003 13.003 0 0 1-13 13A13.003 13.003 0 0 1 7 22 13.002 13.002 0 0 1 20 9a13.015 13.015 0 0 1 13 13zm-7.36-6.77a1.01 1.01 0 0 0-1.41.13l-5 6a1.01 1.01 0 0 0 .13 1.41c.181.148.406.229.64.23.297.001.58-.13.77-.36l5-6a1.01 1.01 0 0 0-.13-1.41z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopmodalIcon3);
export default __webpack_public_path__ + "static/media/stopmodal-icon3.6aef898418da339485fe72a286dc997e.svg";
export { ForwardRef as ReactComponent };